import React from 'react';

const ImageCardWrapper = (props) => {
  const { title, children, onClickRefreshBtn, onClickExpand } = props;
  return (
    <div className='image-card-wrapper'>
      <div className='analytic-header-wrapper row d-flex'>
        <div className='col-md-7'>
          <span className='analytic-title'>{title}</span>
        </div>
        <div className='col-md-5 d-flex justify-content-end'>
          <>
            <img
              className='me-2 analytic-refresh-icon'
              src={'./assets/icons/dashboard/zoom_out.svg'}
              alt={'completed'}
              onClick={onClickExpand}
            />
          </>
          <>
            <img
              className='mt-1 ms-1 me-4 analytic-refresh-icon'
              src={'./assets/icons/dashboard/sync-icon.svg'}
              alt={'completed'}
              onClick={onClickRefreshBtn}
            />
          </>
        </div>
      </div>
      <div className='analytic-breaker' />

      {children}
    </div>
  );
};

export default ImageCardWrapper;
